<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="ghost-row">
    <PristyIcon class="ghost-icon" :svg-file-name="iconName" />
    <span class="ghost-name">{{ node.name }}</span>
    <span class="ghost-badge" v-tooltip.bottom="$t('ghost.tooltip')">
      <i class="ri-loader-4-line ghost-spinner" />
      {{ $t("ghost.indexing") }}
    </span>
  </div>
</template>

<script>
import PristyIcon from "@/components/PristyIcon.vue";
import iconeService from "@/services/IconeService.js";
import Tooltip from "primevue/tooltip";

export default {
  name: "GhostNodeRow",
  components: {
    PristyIcon,
  },
  directives: {
    tooltip: Tooltip,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconName() {
      try {
        return iconeService.getIcon(this.node);
      } catch {
        return this.node.isFolder ? "folder" : "file-default";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ghost-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  opacity: 0.6;
  background: var(--p-content-hover-background);
  user-select: none;
}

.ghost-icon {
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.ghost-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
}

.ghost-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 1rem;
  background: var(--p-highlight-background);
  color: var(--p-highlight-color);
  font-size: 0.75rem;
  white-space: nowrap;
  cursor: help;
  pointer-events: auto;
}

.ghost-spinner {
  animation: ghost-spin 1s linear infinite;
  font-size: 0.875rem;
}

@keyframes ghost-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
